import { createMuiTheme } from '@material-ui/core/styles'

const arcBlue = "#0B72B9"
const arcBlueGradient = "#0394f8 "
const arcOrange = "#FFBA60"
const arcWhite = "#FFFFFF"

const customPrimary = "#226abc"
const customPrimaryLight = "#226abc"
const customeSecondary = "#4b4b4b"
const lightgrey = "#f0f1f2"
const red ="red"

export default createMuiTheme({
  palette: {
    common: {
      blue: `${arcBlue}`,
      orange: `${arcOrange}`,
      white: `${arcWhite}`,
      lightgrey: `${lightgrey}`,
      red: `${red}`,
      bluegrident : `${arcBlueGradient}`
    },
    primary: {
      main: `${customPrimary}`,
      light: `${customPrimaryLight}`,
    },
    secondary: {
      main: `${customeSecondary}`,
    },
  },
  MuiTableCell: {
    root: {
      padding: "3px",
    },
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        backgroundColor: `${lightgrey}`,
        color: `${customeSecondary}`,
        // boxShadow: theme.shadows[1],
        fontSize: 11,
      },
      arrow: {
        color: `${lightgrey}`,
      },
    },
    // MuiButton: {
    //   containedPrimary: {
    //     background: 'linear-gradient(45deg, #226abc  30%, #0394f8  90%)',
    //     border: 0,
    //     borderRadius: 3,
    //     // boxShadow: '0 3px 5px 2px #0394f8',
    //     color: 'white',
    //     // height: 48,
    //     // padding: '0 30px',
    //   },
    //   containedSecondary : {
    //     background: 'linear-gradient(45deg, #4b4b4b  30%, #747272  90%)',
    //     border: 0,
    //     borderRadius: 3,
    //     color: 'white',
    //   }
    // },
  },
});